export const getHistoryItemsFromResponse = (history) => {
  return history.map((item) => ({
    label: item.log_partner.name_or_key,
    association_type: item.log_partner.association_type,
    name_or_key: item.log_partner.name_or_key,
    id: item.log_partner.id,
    icon: 'history'
  }));
};
